module.exports = __webpack_public_path__ + "static/media/r3.7b66b8b3.jpg";